<template>
    <div>
        <el-header class="navbg" v-show="false">
            <div class="contBox">
                <hq-nav></hq-nav>
            </div>
        </el-header>
        <el-row>
            <div class="vdlbt">
                {{ text }}

                <el-dropdown :hide-on-click="dropDown">
                    <div class="filter">
                        <i class="el-icon-arrow-down"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-checkbox-group v-model="checkList" >
                            <el-dropdown-item v-for="(cont,index) in this.jsonData.labData" :key="index">
                                <el-checkbox  v-if="!cont.fixed" :label="cont.prop">
                                    {{ cont.labels }}
                                </el-checkbox>
                            </el-dropdown-item>
                        </el-checkbox-group>

                        <el-dropdown-item divided style="text-align: center;">
                            <el-button size="mini" @click="filter">筛选</el-button>
                            <el-button size="mini" @click="reset">重置</el-button>
                        </el-dropdown-item>

                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <el-col :span="24" class="vdlBox">
                <el-table
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="tableHeader"
                >
                    <el-table-column
                       v-for="(cont,index) in this.labelData"
                       :key="index"
                       align="center"
                       :prop="cont.prop"
                       :label="cont.labels"
                       :fixed="cont.fixed"
                       :width="cont.width">
                        <template slot-scope="scope">
                            <pre class="pre">{{ scope.row[cont.prop] }}</pre>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-footer class="footer">
            <hq-footer></hq-footer>
        </el-footer>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";

    export default {
        name: "VDLCont",
        props: {
            fMes: {
                type: String,
                default: ' '
            }
        },

        data(){
            return {
                jsonData:[],
                tableData: [],
                labelData:[],
                checkList : [],
                dropDown : false,
                text:""
            }
        },
        methods:{
            objectSpanMethod({row, rowIndex, columnIndex }) {
                let mergeLength = 1;//需要进行横纵合并的列
                if (columnIndex < mergeLength) {
                    let finArray = [1,1];
                    // 处理行数据
                    let cgname = Object.keys(row)[columnIndex]

                    if(rowIndex === 0 || row[cgname] !== this.tableData[rowIndex-1][cgname]){
                        let rowspan = 1;
                        //计算需要进行合并操作的行
                        for(let i=0; i<this.tableData.length-1; i++){
                            // 只合并连续的
                            if(this.tableData[i][cgname] === row[cgname] && this.tableData[i+1][cgname] === row[cgname]){
                                rowspan ++;
                            }
                        }
                        finArray[0] = rowspan;
                    }else {
                        finArray[0] = 0;
                    }

                    // 处理列数据
                    let colkeys = Object.keys(row);
                    let cgvalue = Object.values(row)[columnIndex];
                    if(columnIndex ===0 || row[colkeys[columnIndex-1]] !== row[colkeys[columnIndex]]){
                        let colspan = 1;
                        //计算需要进行合并操作的列
                        for(let i=columnIndex; i<mergeLength; i++) {
                            // 只合并连续的
                            if (row[colkeys[i]]===cgvalue && row[colkeys[i+1]]===cgvalue && i+1<mergeLength) {
                                colspan ++;
                            }
                        }
                        finArray[1] = colspan;
                    } else {
                        finArray[1] = 0;
                    }

                    return finArray

                }
            },
            tableRowClassName({ rowIndex}) {
                if (rowIndex % 2 == 0) {
                    return 'black-row';
                } else {
                    return 'hui-row';
                }
            },
            tableHeader({ rowIndex}){
                if (rowIndex % 2 == 0) {
                    return 'black-row';
                } else {
                    return 'hui-row';
                }
            },
            filter(){
                let val = this.checkList;
                this.labelData = [];

                for ( let i = 0; i < 2; i++){
                    this.labelData.push(this.jsonData.labData[i]);
                }

                for ( let i in val ){
                    for ( let d = 0; d < this.jsonData.labData.length; d++){
                        if (this.jsonData.labData[d].prop === val[i]){
                            this.labelData.push(this.jsonData.labData[d]);
                        }
                    }
                }
            },
            reset(){
                /*this.labelData = [];
                this.tableData = [];
                this.checkList = [];
                for ( let i in this.jsonData.labData ){
                    this.labelData.push(this.jsonData.labData[i]);
                    this.tableData.push(this.jsonData.tabData[i]);
                }*/
                window.location.reload();
            }
        },
        created() {
            let type = this.$route.params.type;
            let text = this.$route.params.text;
            let data = require("../assets/JSON/"+ type +".json");

            this.text = text;
            this.jsonData = data;
            this.tableData = this.jsonData.tabData;
            this.labelData = this.jsonData.labData;
        },
        destroyed() {
            this.tableData = "";
            this.labelData = "";
            this.jsonData = "";
        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer
        }

    }

</script>

<style>
    .vdlBox .el-table--border::after, .el-table--group::after, .el-table::before{
        background-color: #000000;
    }
    .vdlBox .el-table__fixed-right::before, .el-table__fixed::before{
        background-color: unset;
    }
    .vadBox .el-table__body-wrapper{
        height: calc( 100vh - 12rem) !important;
    }
    .vdlBox .el-table__body-wrapper::-webkit-scrollbar{
        width: 6px;
        height: 10px;
    }
    .vdlBox .el-table__body-wrapper::-webkit-scrollbar-thumb{
        border-radius: 2px;
        height: 60px;
        background: #eee;
    }
    .vdlBox .el-table__body-wrapper::-webkit-scrollbar-track{
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        background: rgba(0,0,0,0.4);
    }
    .vdlBox{
        background: #000000;
        min-height: calc( 100vh - 11.8rem);
        overflow: auto;
    }
    .vdlbt{
        background: #000000;
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Bold;
        margin: 0;
        font-size: 2rem;
        padding: 1rem 0;
    }
    .filter{
        text-align: center;
        padding-left: -1px;
        width: 20px;
        height: 20px;
        color: #ffffff;
        margin: 0;
        float: right;
        display: inline-block;
        box-sizing: border-box;
    }
    .filter .el-icon-arrow-down{
        margin-left: -1px;
    }
    .navbg{
        background: url("../assets/images/navbg.jpg") no-repeat top center;
        background-size: 100% 100%;
    }
    .pre {
        font-family: AlibabaPuhuiTiR;
        font-size: 1rem;
        line-height: 2rem;
        margin: 0;
        white-space: pre-line;
    }
    .vdlBox .el-table{
        background: #000000;
    }
    .vdlBox .tableHeader{
        background: #000000;
        color: #ffffff;
    }
    .vdlBox .el-table .black-row {
        background: #000000;
        color: #ffffff;
    }

    .vdlBox .el-table .hui-row {
        background: #191919;
        color: #ffffff;
    }

    .vdlBox .el-table>>> tbody tr:hover>td,
    .vdlBox .el-table>>> tbody th:hover>td{
        background-color:#000000!important;
        color: #ffffff!important;
    }
    .vdlBox .el-table td, .el-table th.is-leaf{
        border-bottom: none;
    }
    .vdlBox .el-table__body tr:nth-child(odd).hover-row>td{
        background: #000000;
        color: #ffffff;
    }
    .vdlBox .el-table__body tr:nth-child(even).hover-row>td{
        background: #191919;
        color: #ffffff;
    }
    .vdlBox .el-table th, .el-table tr{
        background-color: #191919;
        color: #ffffff;
        border-bottom: 1px solid #191919;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.125rem;
    }
</style>
